import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';

@Injectable()
export class DashboardSupportGuard implements CanActivate {

  constructor(private oidcSecurityService: OidcSecurityService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const queryTenantId = route.queryParams['tenantId'] ?? '';
    if (queryTenantId === '') {
      // url is expected to contain a 'tenantId' query parameter
      // Here we assume the url is manually (and incorrectly) entered in browser addressbar
      // In response to this false condition we simply show a (false) page
      return of(true);
    }
    sessionStorage.setItem('mruTenant-support', queryTenantId);
    this.oidcSecurityService.logoffLocal('dashboard-support-ui');
    // GET /connect/authorize?client_id=dashboard-support-ui&....
    this.oidcSecurityService.authorize('dashboard-support-ui', { customParams: { acr_values: 'tenant:' + queryTenantId }});
    return of(false);
  }
}
